import { ChainId, Ether, Percent, Token, TradeType } from '@uniswap/sdk-core';
import {
  AlphaRouter,
  CurrencyAmount,
  SwapOptionsSwapRouter02,
  SwapRoute,
  SwapType,
} from '@uniswap/smart-order-router';
import { providers } from 'ethers';
import JSBI from 'jsbi';

export type CustomToken = {
  name: string;
  symbol: string;
  address: `0x${string}`;
  chainId: number;
  decimals: number;
  logoURI: string;
  isNative: boolean;
};

export const TBET_TOKEN: CustomToken = {
  name: 'TerabetToken',
  address: process.env.REACT_APP_BET_TOKEN_ADDRESS as `0x${string}`,
  symbol: '$TBET',
  decimals: 18,
  chainId: Number(process.env.REACT_APP_CHAIN_ID),
  logoURI: 'https://s3.ap-southeast-1.amazonaws.com/terabet.io/assets/images/logo32.png',
  isNative: false,
};

export const MY_TOKEN_LIST: CustomToken[] = [
  {
    name: 'TerabetToken',
    address: '0x59caf3854A29D886080Fe28DfECb2DEc61cF5BA2',
    symbol: '$TBET',
    decimals: 18,
    chainId: 56,
    logoURI: 'https://s3.ap-southeast-1.amazonaws.com/terabet.io/assets/images/logo32.png',
    isNative: false,
  },
  // {
  //     "name": "BNB",
  //     "address": "0x",
  //     "symbol": "BNB",
  //     "decimals": 18,
  //     "chainId": 56,
  //     "logoURI": "https://pancakeswap.finance/images/tokens/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.png",
  //     isNative: true

  // },
  // {
  //     "name": "WBNB Token",
  //     "symbol": "WBNB",
  //     "address": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  //     "chainId": 56,
  //     "decimals": 18,
  //     "logoURI": "https://pancakeswap.finance/images/tokens/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c.png",
  //     isNative: false

  // },
  {
    name: 'Binance-Peg BSC-USD',
    address: '0x55d398326f99059fF775485246999027B3197955',
    symbol: 'USDT',
    decimals: 18,
    chainId: 56,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
    isNative: false,
  },
  {
    name: 'Binance-Peg USD Coin',
    address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    symbol: 'USDC',
    decimals: 18,
    chainId: 56,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
    isNative: false,
  },
  {
    name: 'Binance-Peg BTCB Token',
    address: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    symbol: 'BTCB',
    decimals: 18,
    chainId: 56,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    isNative: false,
  },
  {
    name: 'Binance-Peg Ethereum Token',
    address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    symbol: 'ETH',
    decimals: 18,
    chainId: 56,
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
    isNative: false,
  },
];

const provider = new providers.JsonRpcProvider('https://bsc-dataseed.binance.org/');

const router = new AlphaRouter({
  chainId: ChainId.BNB as number,
  provider,
});

export const getRoute = async (
  fromToken: CustomToken,
  address: string,
  amount: number,
): Promise<SwapRoute | null> => {
  const options: SwapOptionsSwapRouter02 = {
    recipient: address,
    slippageTolerance: new Percent(50, 10_000),
    deadline: Math.floor(Date.now() / 1000 + 1800),
    type: SwapType.SWAP_ROUTER_02,
  };
  const from = fromToken.isNative
    ? Ether.onChain(fromToken.chainId)
    : new Token(
        fromToken.chainId,
        fromToken.address,
        fromToken.decimals,
        fromToken.symbol,
        fromToken.name,
      );
  const to = new Token(
    MY_TOKEN_LIST[0].chainId,
    MY_TOKEN_LIST[0].address,
    MY_TOKEN_LIST[0].decimals,
    MY_TOKEN_LIST[0].symbol,
    MY_TOKEN_LIST[0].name,
  );
  const route = await router.route(
    CurrencyAmount.fromRawAmount(from, fromReadableAmount(amount, from.decimals)),
    to,
    TradeType.EXACT_INPUT,
    options,
  );
  return route;
};

export function fromReadableAmount(amount: number, decimals: number): JSBI {
  const extraDigits = Math.pow(10, countDecimals(amount));
  const adjustedAmount = amount * extraDigits;
  return JSBI.divide(
    JSBI.multiply(
      JSBI.BigInt(adjustedAmount),
      JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(decimals)),
    ),
    JSBI.BigInt(extraDigits),
  );
}

function countDecimals(x: number) {
  if (Math.floor(x) === x) {
    return 0;
  }
  return x.toString().split('.')[1].length || 0;
}
